<button mat-raised-button (click)="auth.logout()" class="jaguarFont">
  <mat-icon matListIcon>exit_to_app</mat-icon><span matLine> Logout</span>
</button>
